export default __webpack_public_path__ + "static/media/SideBarSearch.638d72cb.svg";